module.exports = __webpack_public_path__ + "static/media/chevron-up-bg.ba5865ef.svg";